import { AfterViewInit, Component, ElementRef, HostListener, Inject, Injector, OnDestroy, OnInit, Renderer2, TransferState, effect, inject, makeStateKey } from '@angular/core';
import { CdsIconModule } from '@citi-gcg-173875/citi-common-ui-cds';
import { CCModuleComponent, CategoryHeaderComponent, CategoryNavBarComponent, CompareCardStickyComponent, EngagementContainerComponent, FilterChipsComponent, HeroBannerComponent, LegalBarComponent, TDSService, TdsOutputService } from '@citi-gcg-173875/cbol-marketing-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { MktCardRetrievalService, MktContentService, MktContentStorageService, MktDynamicOfferService, MktModalService, MktSEOService } from 'src/app/core/services';
import { Subscription, timer, Subject, firstValueFrom } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MppRedesignService } from './mpp-redesign.service';
import { CommonService, OfferUtilService, PqpsUtilService } from 'src/app/common/services';
import { FootnoteService } from 'src/app/common/services/footnote.service';
import { MktBrandingService } from 'src/app/common/services/mkt-branding.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { CookieService, WINDOW } from '@citi-gcg-173875/citi-utils';
import { AdaFriendlyNamePipe } from 'src/app/common/pipes/ada-friendly-name.pipe';
import { TaggingService } from './tagging-service.service';
import { MktAEMService } from 'src/app/core/services/mkt-aem.service';
import { QPStoreService } from 'src/app/common/services/qp-store.service';

const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>('isBundleLoaded');
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const ADDITIONAL_INFO_PAGES = 'Additional_Info_Pages';

// TODO: set the category Maaping
const cardsCategory = {
  "vac": "CitiVACNGA",
  "explore": "CitiHomeNGA",
  "retail-store-credit-cards": "CITICRSNGA",
  "default": "CitiNONVACNGA",
}
const TDS_COMPONENTS = [
  HeroBannerComponent,
  CCModuleComponent,
  CategoryNavBarComponent,
  CategoryHeaderComponent,
  FilterChipsComponent,
  CompareCardStickyComponent,
  LegalBarComponent,
  EngagementContainerComponent
];

@Component({
  selector: 'mpp-redesign',
  standalone: true,
  imports: [
    CdsIconModule,
    CommonModule,
    ...TDS_COMPONENTS,
  ],
  providers: [TDSService],
  templateUrl: './mpp-redesign.component.html',
  styleUrl: './mpp-redesign.component.scss',
})
export class MppRedesignComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageDataObj: any;
  public selectedIndex: number[] = [];
  public pageNotFound: boolean = false;
  public pageName: string;
  public mppCategory: string;
  public tagging_content: any;
  public isBundleLoaded: boolean;
  private sub: Subscription = new Subscription();
  private category: any;
  private afcCode: any;
  private intcCode: any;
  private flowId: string;
  private filter: string;
  private screenId: any;
  private acquisitionType: any;
  private invitationNumber: any;
  private aoOfferParams: any;
  private offerDataHash: any;
  private oc: any;
  private flagPQPS: boolean;
  private pageId: any;
  private isBannerCallRequired: boolean = false;
  private isModalOpen: any;
  public selectedPids: any[] = [];
  public showSticky: boolean = false;
  currentCategories: any;
  cardsListOnCategories: any = [];
  swipeCoord: [number, number];
  swipeTime: number;
  displayHeroBanner: boolean = false;
  displayBanner: boolean = false;
  isBrowser: boolean = false;
  searchString: string = '';
  private scrollSubject = new Subject<void>(); // Subject to handle scroll events
  public variation: any;
  public variationStartComment: any;
  public variationEndComment: any;
  constructor(
    private state: TransferState,
    private _offerUtilService: OfferUtilService,
    private route: ActivatedRoute,
    private _mppRedesignService: MppRedesignService,
    private mktSEOService: MktSEOService,
    private titleService: Title,
    private _mktContentService: MktContentService,
    private pqpsUtilService: PqpsUtilService,
    private footnoteService: FootnoteService,
    private router: Router,
    private mktBrandingService: MktBrandingService,
    private modalService: MktModalService,
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    private _tdsService: TDSService,
    private _commonService: CommonService,
    private _cookieService: CookieService,
    private _tagging: TaggingService,
    private _mktDynamicOfferService: MktDynamicOfferService,
    private _contentStorageService: MktContentStorageService,
    private _mktCardRetrievalService: MktCardRetrievalService,
    private adaFriendlyNamePipe: AdaFriendlyNamePipe,
    private _mktAEMService: MktAEMService,
    private tdsOutputService: TdsOutputService,
    private qpStoreService: QPStoreService,
    private sanitizer: DomSanitizer,
    @Inject(WINDOW) private _window,
    @Inject(DOCUMENT) private _document: any,
  ) {
    this.isBundleLoaded = this.state.get(IS_BUNDLE_LOADED_KEY, false);
    this.isBrowser = this._mppRedesignService.isBrowser;
    this.variationStartComment = this.sanitizer.bypassSecurityTrustHtml("<!-- VARIATION DATA START -->");
    this.variationEndComment = this.sanitizer.bypassSecurityTrustHtml("<!-- VARIATION DATA END -->");
    effect(
      () => {
        this.getOutputEmitterData();
        this.categoryUrlUpdate();
      },
      { injector: inject(Injector) }
    );
  }
  ngOnInit() {
    // Subscribe to the debounced scroll events
    this.sub.add(this.scrollSubject
      .pipe(debounceTime(2000)) // Debounce scroll events by 500ms
      .subscribe(() => {
        this.handlePriceDependentEvent();
      }));
     // Route query parameters subscription
     this.sub.add(
      this.route.queryParams.subscribe(params => {
        const routeData = this.route.snapshot.data;
        this.pageName = routeData.pageName.replace(/\./g, '');
        this.mppCategory = routeData.category?.replace(/\./g, '') || "";
        this.category = params['category'] || this.route.snapshot.url[0]?.path || "/";
        this.afcCode = params['afc'] || "";
        this.intcCode = params['intc'] || "";
        this.flowId = params['flowId'] || "";
        this.filter = params['filter'] || "";
        this.screenId = params['screenId'] || "";
        this.acquisitionType = params['activityType'] || "";
        this.invitationNumber = params['invitationNumber'] || "";
        this.aoOfferParams = params['aoOfferParams'];
        this.offerDataHash = params['offerDataHash'] || "";
        this.oc = params['OC'] || "";
        this.variation = params['variation'] || "";
        this.flagPQPS = this.pqpsUtilService.checkPQPS(this.pageName);
        this.qpStoreService.setEAPPageQueryParams(params, this.qpStoreService.PAGE_TYPE_MPP);
        this.afcCode = this.qpStoreService.setMPPQPCookie(this.qpStoreService.MPP_EAP_QS_COOKIE) || this.afcCode;
        this._offerUtilService.flowParams = {
          category: this.category,
          intc: this.intcCode,
          screenId: this.screenId,
          afc: this.afcCode,
          filter: this.filter,
          flowId: this.flowId,
          acquisitionType: this.acquisitionType,
          invitationNumber: this.invitationNumber,
          aoOfferParams: this.aoOfferParams,
          oc: this.oc,
          variation: this.variation
        };
      this.getSanitizedSearchString();
      this.pageOnInIt();
      }));

    // Dynamic pricing subscription
    this.sub.add(
      this._mktDynamicOfferService.getPriceDetails().subscribe(priceDetails => {
        if (priceDetails.length > 0) {
          // console.log(`>>> ${this.pageName}: Proceed with dynamic Values...`);
          this.handleDynamicPricing(priceDetails);
          this.initializeExternalUrls();
          this.tagging_content = this.pageDataObj?.PageInfo?.taggingDetails;
          this._tagging.productList = this.pageDataObj.cardData.flatMap(data =>
            data.productList
              .filter(t => t.type === 'card')
              .map(t => ({ ...t.cardDetail, section: data.categoryHeader.headerText.plaintext }))
          );

          const liveRampResponse = this._mktDynamicOfferService.getDatatoDl();
          const categoryName = this.pageName === 'vac' ? "View All Cards" : this.pageDataObj.navBarData.categoryTabs.find(tab => tab.categoryKey === this.mppCategory)?.categoryName || "";
          const rocketFuelResponse = this._mktDynamicOfferService.rocketFuelDefaultResponse.map(({ contentID }) => this.getRocketFuelAndBannerDataByContentId(contentID));

          this._tagging.initTaggingTransformationCc(this.pageName, this.tagging_content, rocketFuelResponse, categoryName, liveRampResponse);

          if (this.flowId && this.pageDataObj.navBarData) {
            this.pageDataObj.navBarData.categoryTabs.forEach(tab => {
              tab.categoryLinkUrl = this._mppRedesignService.setParamsToURL(tab.categoryLinkUrl, `flowId=${this.flowId}`)?.href;
            });
          }
        }
      })
    );

    // Banner content subscription
    this.sub.add(
      this._mktDynamicOfferService.getBannerContent().subscribe(rocketFuelResponse => {
        if (rocketFuelResponse && Object.keys(rocketFuelResponse).length > 0) {
          this._mktDynamicOfferService.callRfxpuidurl(rocketFuelResponse?.UIDMatchHTML);
          this._mktDynamicOfferService.rocketFuelDefaultResponse = rocketFuelResponse.ContentData;
          const contentData = this._mktDynamicOfferService.rocketFuelDefaultResponse.map(({ contentID, clickURL, moduletype }) => ({ contentID, clickURL, moduletype }));
          this.handleEngagementPlacements(contentData);
          this.isBannerCallRequired = false;
        } else {
          console.error("RocketFuel response is empty or invalid.");
        }
      })
    );
  }

  pageOnInIt(){
    // Tagging pased product Name
    const bannerConfigContent = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
    this._tagging.taggingCardNameMap = JSON.parse(bannerConfigContent.productType || '{}');
    this._mppRedesignService.activePids = Object.keys(this._tagging.taggingCardNameMap) || [];
    const pageConfig = JSON.parse(bannerConfigContent.config || '{}');
    const workFlow = this.pageName === 'mpp' ? this.mppCategory : this.pageName;
    // this._offerUtilService.flowParams = { ...this._offerUtilService.flowParams, afc: this.afcCode };
    this.isBannerCallRequired = pageConfig[workFlow]?.isBannerCallRequired || false;  // Page level banner control
    this.displayHeroBanner = this.isBannerCallRequired && pageConfig[workFlow]?.rocketFuelDefaultResponse.length > 0;
    this.displayBanner = this.isBannerCallRequired;
    // Setting the default rocket fuel response, when personalization enabled.
    if(this.isBannerCallRequired){
      this._mktDynamicOfferService.rocketFuelDefaultResponse = pageConfig[workFlow].rocketFuelDefaultResponse;
      this._offerUtilService.setBannerTaggingVendorData();
    } else {
      this._mktDynamicOfferService.rocketFuelDefaultResponse = [];
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
   this.scrollSubject.next(); // Emit scroll event to the Subject
  }

  private handlePriceDependentEvent() {
    if (!this._mppRedesignService.isBrowser) return;
    console.log('Handling scroll event...');
    this.handleDynamicPricing(); // Example logic to execute on scroll
    this.initializeExternalUrls();
  }

  private handleDynamicPricing(priceDetails = this.state.get(PRICE_DETAILS_KEY, [])) {
    this.pageDataObj.cardData.map(({ productList }) => productList).map(obj => {
      obj.map((data) => {
        if (data?.type !== 'card') return;
        let { cardDetail = { isPreLoginMbolFlow: false, isPostLoginMbolFlow: false, app: '', PID: '', productType: '' }, cardArtData, ctaData, legalLinks } = data;
        const { isPreLoginMbolFlow, isPostLoginMbolFlow, app } = cardDetail;
        let mbolParams = !!this.flowId ? ({ pre: this._offerUtilService.isMbolPreLoginFlow(this.flowId, isPreLoginMbolFlow), post: this._offerUtilService.isMbolPostLoginFlow(this.flowId, isPostLoginMbolFlow), app }) : ({});
        const priceObj = priceDetails.filter(({ productIdentifier }) => (productIdentifier == cardDetail.PID))[0];
        if (!priceObj) return;
        this._mppRedesignService.refreshPDPLink(ctaData.cardDetailLinkContent.href, ctaData, cardArtData, priceObj, this.pageDataObj);
        console.log(`${this.pageName}: Loading dynamic URLs...`);
        const crsPricingInfoLink = legalLinks?.filter(t => t?.text?.toLowerCase().includes('pricing'))?.[0]?.href || null;
        if (crsPricingInfoLink) priceObj["terms-link"] = crsPricingInfoLink;
        priceObj.isMbol = (mbolParams.pre || mbolParams.post);
        this._mppRedesignService.getDynamicUrls({ priceObj, pageId: this.pageId, flowParams: this._offerUtilService.flowParams, mbolParams });
        this.loadPriceInformation(cardDetail);
      });
    });
    console.log(`>>> ${this.pageName}: All process completed successfully...`)
  }

  private updateCompareCards(): void {
    if (!this._mppRedesignService.isBrowser) return;
    const compareCookie: any = this._commonService.getCookie('compareCards') || [];
    if (compareCookie.length > 0 && compareCookie?.[0].includes('view-all-cards')) {
      const compareCards = compareCookie?.map(card => card.split(':')).map(value => value[1]).join('|');
      this._commonService.updateCookie('compareCards', compareCards);
    }
  }

  // Additional info modal feature start
  private getAdditionalInfoData(cardName = '') {
    const additionalInfoCardContent = this._mktContentService.get(ADDITIONAL_INFO_PAGES, 'copy', cardName, undefined);
    const cardAdditionalInfoContent = !!additionalInfoCardContent && JSON.parse(additionalInfoCardContent.TEXT || '{}');
    return cardAdditionalInfoContent;
  }

  openAdditionalInfoPage(event: MouseEvent, addInfoCardName: string, addInfoPDPContentId: string) {
    if (event.type === "keyup" && event['keyCode'] != 13) return;
    const additionalInfoData = this.getAdditionalInfoData(addInfoPDPContentId);
    const additionalInfoDataObj = {
      content: '',
      siteCatalyst: {},
      showCancelButton: true,
      cancelButtonText: 'Close',
      primaryButtonText: '',
      url: '',
      useDefaults: false,
      isModalScrollable: true,
      ...additionalInfoData
    };
    additionalInfoDataObj.genericTemplateContent = additionalInfoData;

    if (!this.isModalOpen) {
      this.isModalOpen = true;
      const modalInstance = this.modalService.openModal(event, additionalInfoDataObj, false);

      if (true) {
        const handleOnClose = () => {
          this.closeAdditionalInfoPage();
          modalCloseSub.unsubscribe();
          modalContinueSub.unsubscribe();
        };

        // Subscribe to modal close emitter
        const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

        // Subscribe to modal continue emitter
        const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));
      }
    }

    return false;
  }

  private closeAdditionalInfoPage() {
    console.log('onclose -model');
    this.isModalOpen = false;
  }
  // Additional info modal feature end

  private loadPriceInformation(cardDetail) {
    console.log(`${this.pageName}: Rendering Dynamic data on page...`);
    if (this.flagPQPS) {
      this.pqpsUtilService.updatePricingValuesPQPS(cardDetail.PID, this.elementRef, this.renderer2, this.acquisitionType, this.oc);
    } else {
      this._offerUtilService.populateDynamicValues(cardDetail.PID, this.elementRef, this.renderer2, cardDetail.productType, cardDetail.app);
    }
    const instance = setTimeout(() => {
      // get footnote attributes from AEM
      cardDetail.additionalInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "class": "text-decoration-none", "style": "cursor: pointer" };
      cardDetail.pricingInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "class": "text-decoration-none", "style": "cursor: pointer", "target": "_blank", "rel": "noopener" };
      this.footnoteService.addFootNote(this.elementRef, this.renderer2, cardDetail, this.openAdditionalInfoPage, this);
      clearTimeout(instance);
    }, 0);
  }

  private loadContent() {
    try {
      // console.log(`>>> ${this.pageName}: AEM and ICMS Contents loading...`);
      const aemContent = JSON.parse(this._contentStorageService.getByAppId(`${this.pageName}`) || 'null');
      if (aemContent == null) throw "AEM Content Not Loaded"; else console.log(`>>> ${this.pageName}: AEM and ICMS Contents Loaded!`);
      if(!this.isBannerCallRequired) {
        aemContent.PageInfo.item.bannerPositions = [];
        aemContent.PageInfo.item.defaultEngagementModules = [];
      }else{
        delete aemContent.banner;
        delete aemContent.mppBanner;
      }
      this.pageDataObj = this._mppRedesignService.getDataBasedOnPageName(aemContent, this.pageName, this.mppCategory);
      // console.log(`>>> ${this.pageName}: Page data prepared.`);
      this.initilizeSetUp(this.pageDataObj || {});
      console.log(`>>> ${this.pageName}: SSR process completed!`);
      this.browserInit();
    } catch (error) {
      console.error(`>>> ${this.pageName}: Failed to load content!`, error?.message);
      this.router.navigateByUrl('page-not-found');
    }
  }

  async updateDefaultVariables({ intc, afc }) {
    await this.pageDataObj.cardData.map(({ productList }) => productList).map(obj => {
      obj.map((data) => {
        if (data?.type !== 'card') return;
        if (!!data.cardDetail) {
          let { screenId } = data.cardDetail;
          if (!this.screenId) this.screenId = screenId || '';
          if (!this.intcCode) this.intcCode = intc || '';
          if (!this.afcCode) this.afcCode = afc || '';
          this._offerUtilService.flowParams = {
            ...this._offerUtilService.flowParams,
            screenId: this.screenId,
            intc: this.intcCode,
            afc: this.afcCode,
          }
        }
      })
    });
  }

  initilizeSetUp(response) {
    // console.log(`>>> ${this.pageName}: initial setup initiated...`);
    if (this.pageNotFound) return;
    this.isBundleLoaded = (Object.keys(response).length > 0);
    this.state.set(IS_BUNDLE_LOADED_KEY, this.isBundleLoaded);
    // console.log(`>>> ${this.pageName}: Updating default variables...`);
    this.updateDefaultVariables(response?.PageInfo);
    this.selectedIndex = Array(response.cardData.length).fill(0);
    this.pageId = cardsCategory[this.pageName] || cardsCategory["default"];
    let seoTags = this.formatSeoData(response?.PageInfo);
    if(!this._mppRedesignService.isBrowser) this.mktSEOService.setContentfulSeoTags(seoTags);
    this.titleService.setTitle(response?.PageInfo?.pageTitle?.plaintext?.trim());
  }

  private async browserInit() {
    if (this._mppRedesignService.isBrowser) {
      // console.log(`>>> ${this.pageName}: Fetching dynamic values...`);
      // Pricing placeholder replacement handle
      this._offerUtilService.version = this.pageName !== 'mpp' ? 'v2' : 'v1';
      this._offerUtilService.loadBundleContent({ isAddInfo: true });
      if(this.isBannerCallRequired) await this._mktDynamicOfferService.setLiveRampPixel();
      this.getDynamicPricing();
      this.setPageCookie();
      this.setClassOnResize();
      this.loadCompareImgs();
      this.updateCompareCards(); // check with business this is required
      this.updateVACFilterChips();
    }
  }

  private updateVACFilterChips() {
    this.sub.add(timer(0).subscribe(()=>{
      const filterValue = (this.filter?.toLocaleLowerCase() || '').trim();
      if(this.pageName == 'vac' && !!this.filter) {
        let selectedChip = this.pageDataObj.cardData[0].chipsFilterData.filterChips.find(({ filterKey }) => filterKey === filterValue) || {};
        if (Object.keys(selectedChip).length > 0) {
          selectedChip.status = true;
          this.onFilterChipSelect({ selectedChips: [{ ...selectedChip }] });
        }
      }
    }));
  }

  loadPQPSContent() {
    // TODO: PQPS FLOW
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private getDynamicPricing = () => this._offerUtilService.getAllDynamicOffer({ pageId: this.pageId, affinityId: this.afcCode, category: this.category, screenId: this.screenId, intc: this.intcCode, isBannerCallRequired: this.isBannerCallRequired, rewardProgramType: 'VAC' }, message => console.log(`MPP: Price loaded ${message}`));

  ngAfterViewInit() {
    this.loadContent();
  }

  public onNavBarLinkClick(event: Event, pList = [], section = '') {
    const target = event.target as HTMLElement;
    const text = target.innerText || '';
    const linkText = text.replace(/\d+\s*/g, '').trim();
    const { categoryName } = (this.pageName === 'vac') ? { categoryName: "View All Cards" } : this.pageDataObj.navBarData.categoryTabs.filter(({ categoryKey }) => (this.mppCategory === categoryKey))[0];
    this._tagging.tdsHeaderLinkClick(this.pageName, this.tagging_content, linkText, section, categoryName);
  }

  public selectCheckBoxes(pid: string, section: '') {
    if (!this._mppRedesignService.isBrowser) return;
    this._tdsService.setUpCheckBoxes();
    this._tdsService.loadCompareStickyBanner();
    this.selectedPids = this._tdsService.getCookie("compareCards");
    const filterProducts = this.pageDataObj.cardData.flatMap(({ productList }) => productList.filter(({type}) => type === 'card')).map(({ cardDetail }) => cardDetail).filter(({ PID }) => PID == pid)  || [];
    const { categoryName } = (this.pageName === 'vac') ? { categoryName: "View All Cards" } : this.pageDataObj.navBarData.categoryTabs.filter(({ categoryKey }) => (this.mppCategory === categoryKey))[0];
    if (this.selectedPids.includes(pid)) this._tagging.compareCheckBoxClicked(this.pageName, this.tagging_content, filterProducts, section, categoryName);
  }

  @HostListener('window:resize', ['$event'])
  setClassOnResize() {
    if (!this._mppRedesignService.isBrowser) return;
    this.sub.add(timer(0).subscribe(async () => {
      const innerWidth = (this._mppRedesignService.isBrowser)
        ? Math.min(this._window.screen.width, this._window.innerWidth)
        : 1400;

      if (!this.pageDataObj?.cardData) return;

      await Promise.all(this.pageDataObj.cardData.map(async (obj) => {
        const isGrid = this.handleGrid(obj.slider);
        obj.gridColumn = isGrid ? 2 : obj.defaultGridColumn;
        obj.sliderContainer = isGrid;

        if (!isGrid) {
          if (obj.template === 'LARGE_CC_DATA') {
            const cardArtSize = innerWidth < 1200 ? 'md' : 'lg';
            await Promise.all(obj.productList.map(async (prodObj) => {
              prodObj.cardArtData = { ...prodObj.cardArtData, cardArtSize };
            }));
          }

          if (innerWidth < 480) {
            obj.gridColumn = 1; // Mobile
          } else if (innerWidth < 992) {
            obj.gridColumn = obj.template === 'SMALL_CC_DATA' ? 2 : 1; // Tablet
          }
        }
      }));

      if (this.pageDataObj?.heroBanner) {
        const width = window?.innerWidth;
        const CASize = width < 992 ? 'sm' : width < 1200 ? 'md' : width < 1400 ? 'lg' : 'xl';
        this.pageDataObj.heroBanner.cardArtData = {
          ...this.pageDataObj.heroBanner.cardArtData,
          cardArtSize: CASize,
        };
      }
    }));
  }

  private handleGrid(slider: boolean): boolean {
    let width = (this._mppRedesignService.isBrowser) ? (this._window?.screen?.width < this._window?.innerWidth) ? this._window?.screen?.width : this._window?.innerWidth : 1400;
    return (this.pageName == 'explore' && slider === true && width < 992);
  }

  setupSlider() {
    if (!this._mppRedesignService.isBrowser) return;
    const instance = setTimeout(() => {
      const slider = document.querySelector('.slider');
      if (slider) {
        clearTimeout(instance);
        slider.classList.add('swiper-container');
      }
    });
  }

  swipe(e: TouchEvent, currIndex: number, when: string): void {
    if (this.pageName !== "explore" && !this.isBrowser) return;
    const coord: [number, number] = [
      e.changedTouches[0].clientX,
      e.changedTouches[0].clientY,
    ];
    const time = new Date().getTime();

    if (when === "start") {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === "end") {
      const direction = [
        coord[0] - this.swipeCoord[0],
        coord[1] - this.swipeCoord[1],
      ];
      const duration = time - this.swipeTime;

      if (
        duration < 1000 && //
        Math.abs(direction[0]) > 30 && // Long enough
        Math.abs(direction[0]) > Math.abs(direction[1] * 3)
      ) {
        console.log(currIndex, direction);
        // Horizontal enough
        const swipe = direction[0] < 0 ? "next" : "previous";
        // Do whatever you want with swipe
        if (swipe == "next") this.focusCard(currIndex[0], (currIndex[1] + 1))
        else if (swipe == "previous") this.focusCard(currIndex[0], (currIndex[1] - 1))
      }
    }
  }


  onFilterChipSelect({ selectedChips = [] }) {
    if (!this._mppRedesignService.isBrowser) return;
    let pCnt = 0;
    if (selectedChips.length == 0) {
      this.pageDataObj.cardData.map((obj) => { if (obj.hasOwnProperty('chipsFilterData')) obj.filterProductList = obj.productList.filter(({type}) => type === 'card'); });
      this.pageDataObj.cardData.map((obj) => {
        if (obj.hasOwnProperty('chipsFilterData')) {
          obj.filterProductList = obj.productList;
          obj.chipsFilterData.productCount = obj.productList.length;
          pCnt = obj.productList.length;
        }
      });
    } else {
      let filterProductList = [];
      selectedChips.forEach(({ filterKey }, i) => {
        this.pageDataObj.cardData.map((obj) => {
          if (obj.hasOwnProperty('chipsFilterData')) {
            const newFilterArr = (0 === i && filterProductList.length === 0) ? obj.productList.filter(({type}) => type === 'card') : filterProductList.filter(({type}) => type === 'card');
            filterProductList = newFilterArr.filter(({ productChips }) => (this.filterChips(productChips, filterKey)));
            obj.filterProductList = filterProductList;
            obj.chipsFilterData.productCount = obj.filterProductList.length;
            pCnt = obj.filterProductList.length;
          }
        });
      });
    }
    this.handlePriceDependentEvent();
    const chipNames = selectedChips.filter(({ filterName }) => filterName).map(({ filterName }) => filterName).join(',');
    const filterProducts = this.pageDataObj.cardData[0]?.filterProductList.map(({ cardDetail }) => (cardDetail)) || [];
    this._tagging.filterChipsSelected(filterProducts, chipNames, this.tagging_content);
    return this.pageDataObj.cardData;
  }

  filterChips(productChips, filterKey) {
    for (let i = 0; i < productChips.length; i++) {
      if (productChips[i].filterKey === filterKey) return true;
    }
    return false;
  }

  compareBtnClick(event: Event) {
    if (!this._mppRedesignService.isBrowser) return;
    const compareCardList = this._commonService.getCookie();
    const filterProducts = this.pageDataObj.cardData.flatMap(({ productList }) => productList).map(({ cardDetail }) => cardDetail).filter(cardDetail => compareCardList.includes(cardDetail?.pidPT)) || [];
    const { categoryName } = (this.pageName === 'vac') ? { categoryName: "View All Cards" } : this.pageDataObj.navBarData.categoryTabs.filter(({ categoryKey }) => (this.mppCategory === categoryKey))[0];
    this._tagging.compareNowBtnClicked(this.pageName, this.tagging_content, filterProducts, categoryName);
    const compareURL = this._mppRedesignService.setParamsToURL('/credit-cards/compare-credit-cards', `category=${this.category},intc=${this.intcCode},afc=${this.afcCode},flowId=${this.flowId}`);
    const instance = setTimeout(() => { clearTimeout(instance); this._window['open'](compareURL.pathname + compareURL.search, "_self") }, 500);
  }

  private setPageCookie(): void {
    const deletePageCookie = (this.pageName === 'explore') ? 'vac' : 'explore';
    this._cookieService.deleteCookie(`vacReDesign${deletePageCookie}`, '/credit-cards', window?.location?.hostname);
    this._commonService.updateCookie(`vacReDesign${this.pageName}`, 'true');
  }

  cardArtCliked(e) {
    console.log('card art clicked!!!');
  }

  private initializeExternalUrls() {
    if (!this._mppRedesignService.isBrowser) return;
    const instance = setTimeout(() => {
      const externalLinks = this.elementRef.nativeElement.querySelectorAll('.external-link');
      for (let i = 0; i < externalLinks.length; i++) {
        const currentLink = externalLinks[i];
        if(!currentLink.classList.contains('bound')){
          externalLinks[i].classList.add('bound');
          const hrefValue = currentLink.href;
          this.renderer2.listen(currentLink, 'click', (event) => this.openModal(event, hrefValue));
          this.renderer2.setAttribute(currentLink, 'href', 'javascript:;');
          this.renderer2.setAttribute(currentLink, 'target', '_self');
          this.renderer2.setAttribute(currentLink, 'role', 'link');
          this.renderer2.setAttribute(currentLink, 'tabindex', '0');
        }
      }
      clearTimeout(instance);
    }, 0);
  }

  private openModal(event, url) {
    this.modalService.openModal(event, {
      url: url,
      isExternalLink: true,
      primaryButtonText: 'Continue',
      target: '_blank'
    });
  }

  focusCard(i, j) {
    if (!this._mppRedesignService.isBrowser) return;
    if (j < 0 || j > 3) return;
    this.selectedIndex[i] = j;
    const cardElements = <HTMLLinkElement>document.querySelector('#card_group_' + i +'_section_' + j);
    cardElements.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    const instance = setTimeout(() => {
      this.scrollSubject.next();
      const selectedCardRef = <HTMLLinkElement>document.querySelector('#card_group_' + i +'_section_' + j + ' a');
      selectedCardRef.focus();
      clearTimeout(instance);
    }, 500);
  }

  // This method is being used to trigger tagging for Banner CTA click.
  private getOutputEmitterData(): void {
    if (this.tdsOutputService?.ctaLinkClicked()?.target) {
      const target = this.tdsOutputService?.ctaLinkClicked()?.currentTarget as HTMLElement;
      if (!target.classList.contains('banner')) return;
      const bannerContentID = target.dataset.bannercontentid || null;
      this.bannerCTAClicked(null, bannerContentID);
    }
  }

  onPageLinkClick(e: any, section: string) {
    if (!this._mppRedesignService.isBrowser) return;
    const target = e.currentTarget as HTMLElement;
    const text = target.innerText;
    let cardName = target.getAttribute('data-cardName');
    const cardRef = target.getAttribute('data-cardRef');
    if (!cardName) cardName = target.ariaLabel?.replace(target.innerText, "")?.trim() || "";
    const dataId = target.getAttribute('data-id');
    let pid = target.getAttribute('data-pid');
    if (!pid) pid = dataId?.split("-")[1] || "";
    const isApplyNow = dataId?.includes("applyNowUrl") || false;
    const filterProducts = this.pageDataObj.cardData.flatMap(({ productList }) => productList.filter(({type}) => type === 'card')).map(({ cardDetail }) => cardDetail).filter(({ PID }) => PID == pid) || [];
    const { categoryName } = (this.pageName === 'vac') ? { categoryName: "View All Cards" } : this.pageDataObj.navBarData.categoryTabs.filter(({ categoryKey }) => (this.mppCategory === categoryKey))[0];
    if (dataId.includes('prequalURL')) {
      this._tagging.pageLinkClickTagging(this.pageName, this.tagging_content, filterProducts, text, false, categoryName, section);
    }

    if (dataId.includes('additionalInfo')) {
      this.openAdditionalInfoPage(e, cardName, cardRef);
      this._tagging.pageLinkClickTagging(this.pageName, this.tagging_content, filterProducts, text, isApplyNow, categoryName, section);
      this._tagging.additionalInfoClicked(this.pageName, this.tagging_content, filterProducts, categoryName);
    }
    else {
      this._tagging.pageLinkClickTagging(this.pageName, this.tagging_content, filterProducts, text, isApplyNow, categoryName, section);
    }
  }

  // Load cardArt from ICMS content
  private loadCompareImgs() {
    if (!this._mppRedesignService.isBrowser) return;
    this.selectedPids = this._tdsService.getCookie("compareCards");
    this.selectedPids.forEach(pid => {
      const { contentId } = !! this.pageDataObj.navBarData && this.pageDataObj.navBarData.categoryTabs[0].productList.filter(({ cardPid }) => cardPid === pid)[0];
      if (!!contentId) {
        const cardArtUrl = `${this._mppRedesignService.aemImagePrefix}/${contentId}/${contentId}_306x192.webp`;
        const navigationUrl = this._mppRedesignService.setParamsToURL(`${this.pageDataObj.navBarData.categoryTabs[0].categoryLinkUrl}${contentId}`, `category=${this.category},intc=${this.intcCode},afc=${this.afcCode},flowId=${this.flowId}`);
        const { cardName } = this._mktCardRetrievalService.getCardByPid(pid);
        // Extract data needed to build the image url
        this._tdsService.cardUpdate.next({
          [pid]: {
            showCardArt: true,
            pid,
            cardName,
            ariaLabel: this.adaFriendlyNamePipe.transform(cardName, 'ariaLabel'),
            cardArtUrl,
            navigationUrl,
            cardArtSize: 'sm'
          }
        });
      }
    });
  }

  categorySelection(e, defaultSelection) {
    if (!this._mppRedesignService.isBrowser) return;
    const { category, selectedOption } = e;

    category['categoryLinkUrl'] = this._mppRedesignService.setParamsToURL(category?.categoryLinkUrl, `${this.searchString}`);
    try {
      if (defaultSelection === selectedOption) return;
      const name = !!category ? category['categoryName'] : "";
      const { categoryName } = (this.pageName === 'vac') ? { categoryName: "View All Cards" } : this.pageDataObj.navBarData.categoryTabs.filter(({ categoryKey }) => (this.mppCategory === categoryKey))[0];
      this._tagging.navCategory(this.pageName, this.tagging_content, name, categoryName);
      this.sub.add(timer(500).subscribe(() => {
        category?.categoryLinkUrl && this._window['open'](category.categoryLinkUrl, "_self");
      }));
    } catch (_error) {
      category?.categoryLinkUrl && this._window['open'](category.categoryLinkUrl, "_self");
    }
  }

  bannerCTAClicked(event: Event, contentId) {
    if(this._mktDynamicOfferService.rocketFuelDefaultResponse.length == 0) return;// Not for page where banner is not enabled.
    const { bannerContent, rocketFuelbannerContent } = this.getRocketFuelAndBannerDataByContentId(contentId);
    if (!!bannerContent.clickURL) this.triggerZetaCall(bannerContent.clickURL);
    const liveRampResponse = this._mktDynamicOfferService.getDatatoDl();
    this._tagging.bannerClicked(bannerContent.banner_cta, this.tagging_content, bannerContent, this.mppCategory, this.pageName, rocketFuelbannerContent, liveRampResponse);
  }

  private getRocketFuelAndBannerDataByContentId(contentId: string) {
    const bannerContent = this._mppRedesignService.clickUrlMap.get(contentId);
    const rocketFuelbannerContent = this._mktDynamicOfferService.rocketFuelDefaultResponse.filter(({ contentID }) => contentId === contentID)[0];
    return ({ bannerContent, rocketFuelbannerContent });
  }

  private triggerZetaCall = async (clickURL) => await fetch(clickURL)
    .then(resp => console.log('HP: HERO BANNER ZETA TRIGGERED'))
    .catch(err => console.log('Unable to process zeta click link.'));


  formatSeoData(pageInfo) {
    return ({
      ...pageInfo,
      schemaTags: (pageInfo?.schemaTags || []).map(item => {
        const updatedSchemaJson = JSON.parse(JSON.stringify(item.schemaJson).replace(/"schema@type":/g, '"@type":'));
        return { ...item, schemaJson: updatedSchemaJson };
      })
    })
  }

  private handleEngagementPlacements(contentData: any[], isdefault=false): void {
    contentData.map(({ contentID, clickURL, moduletype }) => {
      const idParts = contentID.split('_');
      if (moduletype === 'hero-one') {
        this.fetchHeroBanner({ contentID, clickURL }, isdefault);
      } else if (moduletype === 'card-banner') {
        this.fetchEngagementBanner({ contentID, clickURL }, idParts, isdefault);
      } else if (moduletype === 'footer-banner') {
        this.fetchEngagementBanner({ contentID, clickURL }, idParts, isdefault);
      }
    });
  }

  private async fetchHeroBanner({ contentID, clickURL }, isdefault) {
    try {
      // if (!this._contentStorageService.getByAppId(`Banner_${contentID}`)) return;
      await firstValueFrom(this._mktAEMService.getPageContent('Banner', contentID));
      const bannerData = JSON.parse(this._contentStorageService.getByAppId(`Banner_${contentID}`) || 'null');
      if(bannerData?.banner?.items.length > 0) {
        this.pageDataObj['heroBanner'] = {
          contentID,
          heroBannerData: this._mppRedesignService.transformBannerData(
            bannerData?.banner?.items[0]?.heroBannerData[0], contentID, this.pageDataObj.navBarData.categoryTabs[0].productList
          ),
          cardArtData: this._mppRedesignService.getHeroCAData(
            bannerData?.banner?.items[0]?.heroBannerData[0],
            bannerData?.banner?.items[0]?.cardArtData[0]
          )
        };
        const bannerTagData = {
          "clickURL": clickURL,
          "banner_title": this.pageDataObj['heroBanner']?.heroBannerData?.heroHeading.replaceAll(/\n/g, ""),
          "banner_description": this.pageDataObj['heroBanner']?.heroBannerData?.heroDescription.replaceAll(/\n/g, ""),
          "banner_cta": this.pageDataObj['heroBanner']?.heroBannerData?.items.map(({ label }) => label).join(':')
        }
        this._mppRedesignService.clickUrlMap.set(contentID, bannerTagData || "");
        this.displayHeroBanner = true;
      } else throw '404';
    } catch (error) {
      const bannerConfigContent = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
      const pageConfig = JSON.parse(bannerConfigContent.config || '{}');
      const workFlow = this.pageName === 'mpp' ? this.mppCategory : this.pageName;
      this._mktDynamicOfferService.rocketFuelDefaultResponse = pageConfig[workFlow].rocketFuelDefaultResponse;
      const contentData = this._mktDynamicOfferService.rocketFuelDefaultResponse.filter(({moduletype}) =>  moduletype === 'hero-one');
      if(!isdefault) this.handleEngagementPlacements(contentData, true);
    }
  }

  private async fetchEngagementBanner({ contentID, clickURL }, idParts, isdefault) {
    try {
      // if (!!this._contentStorageService.getByAppId(`Engagement_${contentID}`)) return;
      await firstValueFrom(this._mktAEMService.getPageContent('Engagement', contentID));
      let bannerData = JSON.parse(this._contentStorageService.getByAppId(`Engagement_${contentID}`) || 'null');
      if (bannerData === 'null' || bannerData?.engagementData?.items.length === 0) throw '404';
      const key = `${idParts[1]}-${idParts[2]}-${idParts[3]}`;
      if (!!this.pageDataObj.PageInfo?.bannerPositions) {
        const mapping = this.pageDataObj.PageInfo?.bannerPositions.find(item => item.sectionName.startsWith(key));
        if (mapping) {
          const [, , , cardIndex, productListIndex] = mapping.sectionName.split('-').map(Number);
          bannerData = this._mppRedesignService.transformEngagement(bannerData?.engagementData?.items[0], this.pageName, "engagement", productListIndex - 1)
          this.pageDataObj.cardData[cardIndex].productList[productListIndex - 1] = bannerData;
        }
      } else throw '404';
      const bannerTagData = {
        "clickURL": clickURL,
        "banner_title": bannerData.engagementData?.items[0]?.headerName?.plaintext,
        "banner_description": "",
        "banner_cta": bannerData.engagementData?.items[0]?.featureCards[0]?.ctaData?.button?.map(({ text }) => text)?.join(':')
      }
      this._mppRedesignService.clickUrlMap.set(contentID, bannerTagData || "");
      this.displayBanner = true;
    } catch (error) {
      const bannerConfigContent = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
      const pageConfig = JSON.parse(bannerConfigContent.config || '{}');
      const workFlow = this.pageName === 'mpp' ? this.mppCategory : this.pageName;
      this._mktDynamicOfferService.rocketFuelDefaultResponse = pageConfig[workFlow].rocketFuelDefaultResponse;
      const contentData = this._mktDynamicOfferService.rocketFuelDefaultResponse.filter(({moduletype}) =>  moduletype === 'card-banner');
      if(!isdefault) this.handleEngagementPlacements(contentData, true);
    }
  }

  private categoryUrlUpdate() {
    if (!this.isBrowser) return;
    this.sub.add(timer(0).subscribe(()=>{
      const categoryHeaderLinks = this._document.querySelectorAll(".category-header-link") || [];
      categoryHeaderLinks.forEach((link: HTMLLinkElement) => {
        link.href = `${link.href.split('?')[0]}?${(this.searchString || "")}`
      });
    }));
  }
  
  // Remove cmp and HKOP from query string
  private getSanitizedSearchString(): void {
    const queryString = this.route.snapshot['_routerState'].url.split("?")[1] || '';
    const searchParams = new URLSearchParams(queryString);
    searchParams.delete('cmp');
    searchParams.delete('HKOP');
    this.searchString = searchParams.toString();
  }
}